module.exports = __webpack_public_path__ + "static/la-ventures--grietha-putri-a55aa7b42e8a1121288d9471cbe42c05.mp4";